import React, { FunctionComponent } from 'react';
import styles from './DescriptionTile.module.scss';
import utilityStyles from 'styles/global/utility.module.scss';
import { Link, LinkWrapper, Typography } from 'components/elements';
import { WPAcfDescriptionItem } from 'types/acf/description';
import Card from '../Card/Card';
import DOMPurify from 'dompurify';
import { cleanExternalLink } from 'utils/links';

interface OwnProps {
  data: WPAcfDescriptionItem | null;
  tileHeight: number;
}

type DescriptionTileProps = JSX.IntrinsicElements['div'] & OwnProps;

const DescriptionTile: FunctionComponent<DescriptionTileProps> = props => {
  const { data, tileHeight } = props;

  if (!data) {
    return null;
  }

  const { buttonLabel, buttonLink, description, header } = data;

  return (
    <Card className={styles.wrapper} {...(tileHeight && { maxHeight: tileHeight })}>
      <div data-type="description-tile" className={styles.container}>
        {header && (
          <Typography mobile="new_neue_20_h2" tablet="new_neue_20_h2" desktop="new_neue_20_h2" as="h3" className={styles.header}>
            {header}
          </Typography>
        )}
        {description && (
          <Typography
            as="div"
            mobile="new_ibm_regular_16"
            tablet="new_ibm_regular_16"
            desktop="new_ibm_regular_16"
            className={styles.description}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
          />
        )}
        {buttonLabel && buttonLink && (
          <div className={styles.link}>
            <Link aria-label={`${header} - Link`} href={`/${buttonLink}`}>
              <span aria-hidden="true">{buttonLabel}</span>
              {header && <span className={utilityStyles.visuallyHidden}>{header}</span>}
            </Link>
            <LinkWrapper
              aria-hidden="true"
              tabIndex={-1}
              aria-label={`${header} - Overlay`}
              className={styles.overlayLink}
              href={cleanExternalLink(`/${buttonLink}`)}
            />
          </div>
        )}
      </div>
    </Card>
  );
};

export default DescriptionTile;
